export enum HTTPMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export interface Endpoint {
  method: HTTPMethod;
  path: string;
}

export interface API {
  [key: string]: Endpoint;
}

export type ApiHeaders = {
  "Content-Type": string;
};
